const japanRankingsDashboardPermissions = (
  action,
  permissions,
  institutionId,
  year,
) => {
  if (
    action === 'japanRankingsDashboard:viewPage' &&
    permissions[institutionId].includes(`JAPAN_RANKINGS_DASHBOARD_${year}`)
  ) {
    return true;
  }

  return false;
};

module.exports = {
  japanRankingsDashboardPermissions,
};
